import { createSlice } from "@reduxjs/toolkit";
import {
  fetchMemberReferralByID,
  fetchMemberReferralsItems,
} from "./MemberReferralThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const memberReferralItems = createSlice({
  name: "memberReferral",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMemberReferralsItems.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMemberReferralsItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchMemberReferralsItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    builder.addCase(fetchMemberReferralByID.fulfilled, (state, action) => {
      state.referralDetails = action.payload;
    });
  },
});

export default memberReferralItems.reducer;
